import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { BagResponseV4 } from "./bag.type";
import { buildExpandQueryValue, ExpandOptions } from "./utils/expand";

export async function getCustomerBagByCountry({
  chameleonRequestInstance,
  store,
  customerId,
  lang,
  country,
  keyStoreDataversion,
  authHeader,
  expand,
}: {
  chameleonRequestInstance: ChameleonRequest;
  store: string;
  customerId: string;
  lang: string;
  country: string;
  keyStoreDataversion: string;
  authHeader: string;
  expand?: ExpandOptions;
}) {
  const expandQueryValue = buildExpandQueryValue(expand);

  const url = getApiUrl({
    path: `/commerce/bag/v4/customers/${customerId}/countries/${country}/bag`,
    searchParams: {
      lang,
      keyStoreDataversion,
      ...(expandQueryValue ? { expand: expandQueryValue } : {}),
    },
  });

  const { data, responseHeaders } =
    await chameleonRequestInstance.get<BagResponseV4>(
      url,
      {
        headers: {
          "asos-c-store": store,
          Authorization: authHeader,
        },
      },
      {
        requestType: "GET_BAG_BY_COUNTRY_API",
      },
    );

  return {
    data,
    bagSessionToken: responseHeaders["asos-bag-session-token"] as string,
  };
}
